module.exports = __webpack_public_path__ + "img/q_49_sor.a912457a.png";